import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import { doReopen, type U3129Timesheet } from "./U3129Service";

/**
 * Appel réseau dédié : ne pas invoquer `doReopen` depuis les composants (pattern handlers u2000).
 */
export function useU3129ReopenHandlers() {
  const axios = useU2000AxiosAuthenticated();

  const reopen = useCallback(
    async (timesheetId: string, version: number): Promise<U3129Timesheet> => {
      const res = await doReopen(axios, timesheetId, { id: timesheetId, version });
      const raw = res.data?.result ?? res.data;
      return raw as U3129Timesheet;
    },
    [axios],
  );

  return { reopen };
}
